'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping'),
    tooltip = require('../product/tooltip');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button').attr('disabled', 'disabled');
        }
    }
    $('#main').on('submit', '.submit-order', function () {
        // Clone approach is needed for Safari
        var $placeOrder = $('.js-place-order'),
            $placeOrderClone = $placeOrder.clone().addClass('button--inactive');

        $placeOrder.after($placeOrderClone);
        $placeOrder.remove();
    });

    $('#main').on('click', '.js-place-order', function (e) {
        if ($(this).hasClass('button--inactive')) {
            e.preventDefault();
        }
    });
    tooltip.initShippingFeeCustomToolTipEvents();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/index.js